import { useEffect, useState } from 'react';
import { mutateConfig } from '../../../../api/queryBase';
import { OnboardingDocument } from '../../../../interfaces/Onboarding';
import { getErrorMessage, openNotification } from '../../../../utils/helper';
import { DocumentUploader } from '../../../DocumentUploader';
import { DangerIcon } from '../../../icons';
import { SuitUIButton } from '../../../SuitUIButton';

export const DocumentRejected = ({
    onboardingDocuments,
    refetchUser
}: {
    onboardingDocuments: OnboardingDocument[];
    refetchUser: () => void;
}) => {
    const mutation = mutateConfig({ method: 'post' });
    const { mutate, isLoading: uploading } = mutation<{ fileUri: string }>({
        url: `/corporates/onboarding/upload`
    });

    const [documentList, setDocumentList] = useState<OnboardingDocument[]>([]);

    useEffect(() => {
        const rejectedDocs = onboardingDocuments?.filter(
            (item) => item.status === 0
        );
        setDocumentList(rejectedDocs);
    }, [onboardingDocuments]);

    const handleUpdateDocumentList = ({
        itemId,
        url
    }: {
        itemId: number;
        url: string;
    }) => {
        setDocumentList(
            documentList.map((document) =>
                document.itemId === itemId
                    ? { ...document, documentUrl: url }
                    : document
            )
        );
    };

    const handleMutation = (data: {
        documentItemId: number;
        documentUrl: string;
    }) => {
        mutate(data, {
            onSettled: (_, error) => {
                if (error) {
                    openNotification(
                        'error',
                        getErrorMessage(error) || 'An error occurred'
                    );
                    return;
                } else {
                    refetchUser();
                }
            }
        });
    };
    const handleSubmit = () => {
        documentList.map((item) => {
            handleMutation({
                documentItemId: item.itemId,
                documentUrl: item.documentUrl
            });
        });
    };

    return (
        <div className='flex flex-col pt-[30px] items-center'>
            <div className='flex w-[36px] h-[36px] bg-white rounded-[50%] items-center justify-center'>
                <div className='flex w-[32px] h-[32px] bg-rose rounded-[50%] items-center justify-center'>
                    <DangerIcon />
                </div>
            </div>

            <p className='font-semibold text-ebony pt-4'>Documents Rejected</p>
            <p className='text-sm text-midnightHaze max-w-[352px] text-center mb-6'>
                Your documents has been rejected. Please review it and re-upload
                the correct documents.
            </p>

            <div className='w-full  max-w-[362px] pt-4 mt-4'>
                {documentList?.map((item, index) => (
                    <div className='w-full max-w-[362px] mb-4'>
                        <DocumentUploader
                            useAuthorization
                            key={`upload-doc-${item.documentId}-${index}`}
                            title={item.documentName}
                            runAfterUpload={true}
                            documentItemId={item.itemId}
                            uploaded={item.uploaded}
                            documentUrl={item.documentUrl}
                            status={item.status}
                            onUpload={(url: string) =>
                                handleUpdateDocumentList({
                                    itemId: item.itemId,
                                    url
                                })
                            }
                            rejectedMessage={item.rejectedMessage}
                        />
                    </div>
                ))}
            </div>
            <div className='w-full max-w-[362px] mb-4'>
                <SuitUIButton
                    text='Reupload document'
                    onClick={handleSubmit}
                    fullWidth
                />
            </div>
        </div>
    );
};
